// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Trans = require("../Control.Monad.State.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Ritoppu_Model_Creature = require("../Ritoppu.Model.Creature/index.js");
var Ritoppu_Model_CreatureType = require("../Ritoppu.Model.CreatureType/index.js");
var Ritoppu_Model_Equipment = require("../Ritoppu.Model.Equipment/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var Ritoppu_Model_Rect = require("../Ritoppu.Model.Rect/index.js");
var Ritoppu_Model_Repository = require("../Ritoppu.Model.Repository/index.js");
var Ritoppu_Model_Stage = require("../Ritoppu.Model.Stage/index.js");
var Ritoppu_Model_Tile = require("../Ritoppu.Model.Tile/index.js");
var Ritoppu_Mutation_Repository = require("../Ritoppu.Mutation.Repository/index.js");
var Ritoppu_Mutation_Stage = require("../Ritoppu.Mutation.Stage/index.js");
var Ritoppu_Random = require("../Ritoppu.Random/index.js");
var Ritoppu_Utils = require("../Ritoppu.Utils/index.js");
var pickInDict = function (list) {
    return function (dungeonLevel) {
        return Data_Maybe.maybe(0)(function (v) {
            return v.value;
        })(Data_Foldable.find(Data_Foldable.foldableArray)(function (v) {
            return dungeonLevel >= v.level;
        })(list));
    };
};
var itemsRepository = function (dungeonLevel) {
    return Ritoppu_Mutation_Repository.addToRepository(pickInDict([ {
        level: 4,
        value: 25
    } ])(dungeonLevel))(Ritoppu_Model_Item.LightningScroll.value)(Ritoppu_Mutation_Repository.addToRepository(pickInDict([ {
        level: 6,
        value: 25
    } ])(dungeonLevel))(Ritoppu_Model_Item.FireballScroll.value)(Ritoppu_Mutation_Repository.addToRepository(pickInDict([ {
        level: 2,
        value: 10
    } ])(dungeonLevel))(Ritoppu_Model_Item.ConfusionScroll.value)(Ritoppu_Mutation_Repository.addToRepository(pickInDict([ {
        level: 4,
        value: 5
    } ])(dungeonLevel))(new Ritoppu_Model_Item.MainHandItem(Ritoppu_Model_Equipment.Sword.value))(Ritoppu_Mutation_Repository.addToRepository(pickInDict([ {
        level: 8,
        value: 15
    } ])(dungeonLevel))(new Ritoppu_Model_Item.OffHandItem(Ritoppu_Model_Equipment.Shield.value))(Ritoppu_Model_Repository.initRepository(35)(Ritoppu_Model_Item.HealingPotion.value))))));
};
var generateItems = function (dungeonLevel) {
    return function (roomsCount) {
        return function (stage) {
            var maxItemsPerRoom = pickInDict([ {
                level: 4,
                value: 2
            }, {
                level: 1,
                value: 1
            } ])(dungeonLevel);
            var availablePoses = Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Map.keys(Data_Map_Internal.filter(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Ritoppu_Model_Tile.passibleThrough)(stage.tiles)));
            return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Ritoppu_Random.newInt(0)(maxItemsPerRoom * roomsCount | 0))(function (v) {
                return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Ritoppu_Utils.nTimes(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(v)(Ritoppu_Random.newInt(0)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(availablePoses))))(function (v1) {
                    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Data_Traversable["for"](Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Traversable.traversableArray)(Data_Array.nub(Data_Ord.ordInt)(v1))(function (x) {
                        return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity))(Data_Array.singleton)(Ritoppu_Random.newFromRepository(itemsRepository(dungeonLevel))))(function (v2) {
                            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(new Data_Tuple.Tuple(Data_Maybe.fromMaybe({
                                x: 0,
                                y: 0
                            })(Data_Array.index(availablePoses)(x)), v2));
                        });
                    }))(function (v2) {
                        return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                            items: Data_Map_Internal.fromFoldable(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(Data_Foldable.foldableArray)(v2),
                            creatures: stage.creatures,
                            fovMask: stage.fovMask,
                            player: stage.player,
                            seen: stage.seen,
                            size: stage.size,
                            tiles: stage.tiles
                        });
                    });
                });
            });
        };
    };
};
var filterIntersect = (function () {
    var checkRoom = function (rects) {
        return function (rect) {
            if (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Ritoppu_Model_Rect.intersect(Ritoppu_Model_Rect.outerRect(rect)))(rects)) {
                return rects;
            };
            if (Data_Boolean.otherwise) {
                return Data_Array.cons(rect)(rects);
            };
            throw new Error("Failed pattern match at Ritoppu.DungeonGenerator (line 153, column 3 - line 153, column 48): " + [ rects.constructor.name, rect.constructor.name ]);
        };
    };
    return Data_Foldable.foldl(Data_Foldable.foldableArray)(checkRoom)([  ]);
})();
var creaturesRepository = function (dungeonLevel) {
    var redNagaHatchling = {
        type: Ritoppu_Model_CreatureType.RedNagaHatchling.value,
        stats: {
            maxHp: 20,
            hp: 20,
            defense: 0,
            power: 4
        },
        turn: 0,
        aiStrategy: Ritoppu_Model_Creature.BasicAI.value,
        xp: 35
    };
    var redNaga = {
        type: Ritoppu_Model_CreatureType.RedNaga.value,
        stats: {
            maxHp: 30,
            hp: 30,
            defense: 2,
            power: 8
        },
        turn: 0,
        aiStrategy: Ritoppu_Model_Creature.BasicAI.value,
        xp: 100
    };
    return Ritoppu_Mutation_Repository.addToRepository(pickInDict([ {
        level: 7,
        value: 60
    }, {
        level: 5,
        value: 30
    }, {
        level: 3,
        value: 15
    } ])(dungeonLevel))(redNaga)(Ritoppu_Model_Repository.initRepository(80)(redNagaHatchling));
};
var generateCreatures = function (dungeonLevel) {
    return function (roomsCount) {
        return function (stage) {
            var maxMonstersPerRoom = pickInDict([ {
                level: 6,
                value: 5
            }, {
                level: 4,
                value: 3
            }, {
                level: 1,
                value: 2
            } ])(dungeonLevel);
            var availablePoses = Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Set["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(stage.player.pos)(Data_Map.keys(Data_Map_Internal.filter(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(Ritoppu_Model_Tile.passibleThrough)(stage.tiles))));
            return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Ritoppu_Random.newInt(0)(maxMonstersPerRoom * roomsCount | 0))(function (v) {
                return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Ritoppu_Utils.nTimes(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(v)(Ritoppu_Random.newInt(0)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(availablePoses))))(function (v1) {
                    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Data_Traversable["for"](Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Traversable.traversableArray)(Data_Array.nub(Data_Ord.ordInt)(v1))(function (x) {
                        return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Ritoppu_Random.newFromRepository(creaturesRepository(dungeonLevel)))(function (v2) {
                            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(new Data_Tuple.Tuple(Data_Maybe.fromMaybe({
                                x: 0,
                                y: 0
                            })(Data_Array.index(availablePoses)(x)), v2));
                        });
                    }))(function (v2) {
                        return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                            creatures: Data_Map_Internal.fromFoldable(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(Data_Foldable.foldableArray)(v2),
                            fovMask: stage.fovMask,
                            items: stage.items,
                            player: stage.player,
                            seen: stage.seen,
                            size: stage.size,
                            tiles: stage.tiles
                        });
                    });
                });
            });
        };
    };
};
var buildVLine = function (y1) {
    return function (y2) {
        return function (x) {
            return Data_Functor.map(Data_Functor.functorArray)(function (y) {
                return {
                    x: x,
                    y: y
                };
            })(Data_Array.range(y1)(y2));
        };
    };
};
var buildHLine = function (x1) {
    return function (x2) {
        return function (y) {
            return Data_Functor.map(Data_Functor.functorArray)(function (x) {
                return {
                    x: x,
                    y: y
                };
            })(Data_Array.range(x1)(x2));
        };
    };
};
var builtCorridors = (function () {
    var connect = function (v) {
        return function (v1) {
            if (v.last instanceof Data_Maybe.Just) {
                return {
                    last: new Data_Maybe.Just(v1),
                    tiles: Data_Semigroup.append(Data_Semigroup.semigroupArray)(buildHLine(v.last.value0.x)(v1.x)(v.last.value0.y))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(buildVLine(v.last.value0.y)(v1.y)(v1.x))(v.tiles))
                };
            };
            if (v.last instanceof Data_Maybe.Nothing) {
                return {
                    last: new Data_Maybe.Just(v1),
                    tiles: v.tiles
                };
            };
            throw new Error("Failed pattern match at Ritoppu.DungeonGenerator (line 139, column 50 - line 146, column 41): " + [ v.last.constructor.name ]);
        };
    };
    var $53 = Data_Foldable.foldl(Data_Foldable.foldableArray)(connect)({
        last: Data_Maybe.Nothing.value,
        tiles: [  ]
    });
    return function ($54) {
        return (function (v) {
            return v.tiles;
        })($53($54));
    };
})();
var as = function (tile) {
    return Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return {
            pos: v,
            tile: tile
        };
    });
};
var addRooms = function (dungeonLevel) {
    return function (stage) {
        return function (rooms) {
            var stairs = function (playerPos) {
                return function (stairsDownPos) {
                    return Data_Semigroup.append(Data_Semigroup.semigroupArray)(as(Ritoppu_Model_Tile.StairsUp.value)([ playerPos ]))(as(Ritoppu_Model_Tile.StairsDown.value)([ stairsDownPos ]));
                };
            };
            var corridors = as(Ritoppu_Model_Tile.Floor.value)(builtCorridors(Data_Functor.map(Data_Functor.functorArray)(Ritoppu_Model_Rect.center)(rooms)));
            var builtRooms = Data_Array.concatMap((function () {
                var $55 = as(Ritoppu_Model_Tile.Floor.value);
                return function ($56) {
                    return $55(Ritoppu_Model_Rect.fillRect($56));
                };
            })())(rooms);
            var add = Data_Foldable.foldr(Data_Foldable.foldableArray)(function (v) {
                return Ritoppu_Mutation_Stage.setTile(v.tile)(v.pos);
            });
            var stageWithFloors = function (playerPos) {
                return function (stairsDownPos) {
                    return add({
                        player: {
                            pos: playerPos,
                            stats: stage.player.stats,
                            turn: stage.player.turn,
                            inventory: stage.player.inventory,
                            level: stage.player.level,
                            equipment: stage.player.equipment
                        },
                        tiles: stage.tiles,
                        size: stage.size,
                        seen: stage.seen,
                        items: stage.items,
                        fovMask: stage.fovMask,
                        creatures: stage.creatures
                    })(Data_Semigroup.append(Data_Semigroup.semigroupArray)(stairs(playerPos)(stairsDownPos))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(corridors)(builtRooms)));
                };
            };
            var v = Data_Maybe.fromMaybe({
                a: {
                    x: 0,
                    y: 0
                },
                b: stage.size
            })(Data_Array.head(rooms));
            var lastRoom = Data_Maybe.fromMaybe({
                a: {
                    x: 0,
                    y: 0
                },
                b: stage.size
            })(Data_Array.last(rooms));
            return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Ritoppu_Random.newPoint(v.a.x)(v.a.y)(v.b.x)(v.b.y))(function (v1) {
                return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Ritoppu_Random.newPoint(lastRoom.a.x)(lastRoom.a.y)(lastRoom.b.x)(lastRoom.b.y))(function (v2) {
                    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(generateCreatures(dungeonLevel)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(rooms))(stageWithFloors(v1)(v2)))(generateItems(dungeonLevel)(Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(rooms)));
                });
            });
        };
    };
};
var generator = function (dungeonLevel) {
    return function (size) {
        return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Function["const"](Ritoppu_Random.newRect(size)))(Data_Array.range(1)(30)))(function (v) {
            return addRooms(dungeonLevel)(Ritoppu_Model_Stage.initStage(size))(filterIntersect(v));
        });
    };
};
module.exports = {
    generator: generator
};
